// @ts-nocheck
/*
 * Port of views/dashboard/remarks/remarks.js (150 lines).
 * BYTE-IDENTICAL â€” floating WebRTC + Agent Tools launcher via sessionStorage
 * activeModal key. Same shape as v1's notification.js widget: not a real
 * routed page but a floating button bar. Ported as-is for route parity.
 */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { IoCall } from 'react-icons/io5';
import { FaTasks } from 'react-icons/fa';
import { FillPage } from '@/components/layout/PageContainer';
import { ArrowLeft } from 'lucide-react';

const buttonStyle = (color, isActive) => ({
  border: isActive ? '2px solid #0d6efd' : '2px solid transparent',
  width: '48px',
  height: '42px',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: isActive ? color : '#04005a',
  transition: 'all 0.3s ease',
  cursor: 'pointer',
  marginBottom: '0px',
  marginRight: '5px',
  marginTop: '10px',
  transform: isActive ? 'scale(1.05)' : 'scale(1)',
  borderRadius: '6px',
});

const Remarks = () => {
  const navigate = useNavigate();
  const [activeModals, setActiveModals] = useState([]);

  useEffect(() => {
    const syncFromSession = () => {
      const saved = sessionStorage.getItem('activeModal');
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed)) {
            setActiveModals(parsed);
          } else if (typeof parsed === 'string') {
            setActiveModals([parsed]);
          }
        } catch {
          setActiveModals(saved ? [saved] : []);
        }
      } else {
        setActiveModals([]);
      }
    };

    syncFromSession();

    const handleStorageChange = (e) => {
      const key = e.key || (e.detail && e.detail.key);
      if (key === 'activeModal') syncFromSession();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('sessionStorageChange', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('sessionStorageChange', handleStorageChange);
    };
  }, []);

  const handleButtonClick = (modalType) => {
    setActiveModals((prev) => {
      const isActive = prev.includes(modalType);
      const newModals = isActive ? prev.filter((m) => m !== modalType) : [...prev, modalType];
      sessionStorage.setItem('activeModal', JSON.stringify(newModals));

      if (modalType === 'WEB' && !isActive && !sessionStorage.getItem('showPhone')) {
        sessionStorage.setItem('showPhone', 'true');
      }
      window.dispatchEvent(
        new CustomEvent('sessionStorageChange', {
          detail: { key: 'activeModal', value: newModals },
        }),
      );

      return newModals;
    });
  };

  return (
    <FillPage>
      <div className="mb-3">
        <Button variant="outline" onClick={() => navigate(-1)}>
          â† Go Back
        </Button>

        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            display: 'flex',
            gap: '30px',
            zIndex: 9999,
          }}
        >
          <button
            style={buttonStyle('#ffffffff', activeModals.includes('WEB'))}
            onClick={() => handleButtonClick('WEB')}
            title="WebRTC phone"
          >
            <IoCall
              style={{ fontSize: '24px' }}
              color={activeModals.includes('WEB') ? 'rgb(8, 29, 93)' : 'white'}
            />
          </button>

          <button
            style={buttonStyle('#ffffffff', activeModals.includes('AGENT_TOOLS'))}
            onClick={() => handleButtonClick('AGENT_TOOLS')}
            title="Agent tools"
          >
            <FaTasks
              style={{ fontSize: '24px' }}
              color={activeModals.includes('AGENT_TOOLS') ? 'rgb(8, 29, 93)' : 'white'}
            />
          </button>
        </div>
      </div>
    </FillPage>
  );
};

export default Remarks;
